import { Injectable, OnDestroy } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Subscription, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService implements OnDestroy {
  private tokenCleanupSubscription: Subscription;

  constructor(private cookieService: CookieService) {}

  /**
   * Stores the authentication token in cookies with automatic cleanup after 20 minutes
   * @param token The decoded authentication token
   */
  setAuthToken(token: string): void {
    // Store token in cookies with 20-minute expiry
    const expiryDate = new Date();
    expiryDate.setMinutes(expiryDate.getMinutes() + 60);
    this.cookieService.set('authToken', token, expiryDate, '/', '', true, 'Strict');
    
    // Clean up any existing timer
    this.clearTokenCleanupTimer();
    
    // Set up automatic cleanup after 20 minutes using observable
    this.tokenCleanupSubscription = timer(20 * 60 * 1000).subscribe({
        next: () => {
      this.clearAuthToken();
    }});
  }

  /**
   * Retrieves the authentication token from cookies
   * @returns The authentication token or empty string if not found
   */
  getAuthToken(): string {
    return this.cookieService.get('authToken') || '';
  }

  /**
   * Clears the authentication token from cookies
   */
  clearAuthToken(): void {
    this.cookieService.delete('authToken', '/');
    this.clearTokenCleanupTimer();
  }

  /**
   * Checks if the authentication token exists
   * @returns True if token exists, false otherwise
   */
  hasAuthToken(): boolean {
    return this.cookieService.check('authToken');
  }

  /**
   * Clears the token cleanup timer subscription
   */
  private clearTokenCleanupTimer(): void {
    if (this.tokenCleanupSubscription) {
      this.tokenCleanupSubscription.unsubscribe();
      this.tokenCleanupSubscription = null;
    }
  }

  ngOnDestroy(): void {
    this.clearTokenCleanupTimer();
  }
}
